import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Department } from "../../models/department"

@Injectable({
  providedIn: "root",
})
export class DepartmentDisplayDataResolver
  implements DisplayDataResolver<Department>
{
  typeDisplayName = "Department"

  constructor() {}

  getIcon(entity: Department): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Department): string | undefined {
    return undefined
  }

  getSubTitle(entity: Department): string | undefined {
    return undefined
  }

  getTitle(entity: Department): string {
    return entity.name
  }

  getShortTitle(entity: Department): string {
    return entity.id
  }

  getItemHref(entityOrID: Department | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/department"
    }
    if (typeof entityOrID === "string") return "/app/department/" + entityOrID
    return "/app/department/" + entityOrID.id
  }
}
